import { Card } from '@/components_deprecated/Card'
import { Table } from '@/components_deprecated/Table'
import { Header } from '@/modules/companies'

import { Icon, Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'
import { type GroupRow, type GroupProps } from './types'

const Wrapper = styled(Card)`
  margin: 1rem 0;
  > p {
    margin: 0 0 0 0.5rem;
  }
`

const H2 = styled.h2`
  display: flex;

  margin: 1rem 0 0 8px;
  font-weight: 600;

  div {
    margin-left: 1rem;
  }
`

export const PermissionGroupSection = <TRow extends GroupRow>(
  props: GroupProps<TRow>
) => {
  const { header, loading, table, canEdit, canDelete } = props

  const translations = useTranslate({
    name: 'common.name',
  })

  const numUtilColumns = (canEdit ? 1 : 0) + (canDelete ? 1 : 0)

  return (
    <Wrapper>
      <Header>
        <H2>{header.title}</H2>
        {header.loading && <Loader.Spinner />}
        {header.children}
      </Header>
      {header.description && <p>{header.description}</p>}
      {!loading && (
        <Table
          noShadow
          noBorders
          noHeaderMargin
          noRowMargin
          noData={table.rows.length === 0}
          rowHoverColor="secondary"
        >
          <thead>
            <tr>
              <th>{translations.name}</th>
              {(canEdit || canDelete) && <th colSpan={numUtilColumns}></th>}
            </tr>
          </thead>
          <tbody>
            {table.rows.map(row => (
              <tr key={row.id}>
                <td>{row.name}</td>
                {canEdit && (
                  <td width="1px">
                    <Icon
                      icon="edit"
                      cursor="pointer"
                      color="gray6"
                      hoverColor="secondary"
                      onClick={() => {
                        void table.handleEdit(row)
                      }}
                    />
                  </td>
                )}
                {canDelete && (
                  <td width="1px">
                    <Icon
                      icon="times"
                      cursor="pointer"
                      color="gray6"
                      hoverColor="red"
                      onClick={() => {
                        void table.handleDelete(row)
                      }}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Wrapper>
  )
}
